export function getPrimaryColor() {
    return '#005D99'
}

export function getSecondaryColor() {
    return '#DD7C0D'
}

export function screenSizeCheck() {
    if (window.innerWidth > 1650) {
        return true
    } else {
        return false
    }
}

export function getDataIsdeletedFalse(data){
    let result = []
    for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if(!element.is_deleted){
            result.push(element)
        }
    }
    return result
}